<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Report By</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-flex xs12>
                  <v-autocomplete
                    :items="prtBy"
                    v-model="form.prtBy"
                    :label="labels.prtBy"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('form.prtBy')"
                    data-vv-name="form.prtBy"
                    :data-vv-as="labels.prtBy"
                  ></v-autocomplete>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 v-show="form.prtBy === 'T'">
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Recovery Transaction Date Ranges</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs6 sm6>
                    <cal-picker
                      v-model="form.tranDateFrom"
                      :label="labels.tranDateFrom"
                      :data-vv-as="labels.tranDateFrom"
                      data-vv-name="form.tranDateFrom"
                      :error-messages="errors.collect('form.tranDateFrom')"
                      v-validate="tranDateValidation"
                      :max="this.today"
                    />
                  </v-flex>
                  <v-flex xs6 sm6>
                    <cal-picker
                      v-model="form.tranDateTo"
                      :label="labels.tranDateTo"
                      :data-vv-as="labels.tranDateTo"
                      data-vv-name="form.tranDateTo"
                      :error-messages="errors.collect('form.tranDateTo')"
                      v-validate="tranDateValidation"
                      :max="this.today"
                      :min="this.form.tranDateFrom"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model.number="form.prtCopies"
                      :label="labels.prtCopies"
                      :error-messages="errors.collect('form.prtCopies')"
                      :data-vv-as="labels.prtCopies"
                      data-vv-name="form.prtCopies"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-checkbox
                      :label="labels.useCoinsPct"
                      v-model="form.useCoinsPct"
                      :error-messages="errors.collect('useCoinsPct')"
                      data-vv-name="useCoinsPct"
                      :data-vv-as="labels.useCoinsPct"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 v-show="form.prtBy === 'R'">
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Recovery Doc No.</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model="form.rcvyDocNo"
                      :label="labels.rcvyDocNo"
                      :error-messages="errors.collect('form.rcvyDocNo')"
                      :data-vv-as="labels.rcvyDocNo"
                      v-validate="rcvyDocNoValidation"
                      data-vv-name="form.rcvyDocNo"
                      append-icon="mdi-magnify"
                      @click:append="showClmHelpList = true"
                      @click="showClmHelpList = true"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      v-model.number="form.prtCopies"
                      :label="labels.prtCopies"
                      :error-messages="errors.collect('form.prtCopies')"
                      :data-vv-as="labels.prtCopies"
                      data-vv-name="form.prtCopies"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-checkbox
                      :label="labels.useCoinsPct"
                      v-model="form.useCoinsPct"
                      :error-messages="errors.collect('useCoinsPct')"
                      data-vv-name="useCoinsPct"
                      :data-vv-as="labels.useCoinsPct"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 class="pt-3">
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            {{ labels.export }}
            <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showClmHelpList" width="1280px">
      <claim-help-list
        @close="showClmHelpList = false"
        :fromDate="this.convertDate(form.tranDateFrom)"
        :toDate="this.convertDate(form.tranDateTo)"
        @doAssign="doAssign($event)"
      ></claim-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import ClaimHelpList from '@/components/core/claimManagement/reports/clmRiRcvyR/ClaimHelpList'

export default {
  data() {
    return {
      labels: {
        rcvyDocNo: 'Recovery Document No.*',
        format: 'Export Format',
        export: 'Export',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'Transaction Date To',
        useCoinsPct: 'Use Coins % From UW For Claim Debit Note Printing',
        prtCopies: 'No. of Copies',
        prtBy: 'Print By'
      },
      form: {
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        rcvyDocNo: null,
        clmNo: null,
        format: undefined,
        useCoinsPct: false,
        prtCopies: 1,
        prtBy: 'R'
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      showClmHelpList: false,
      panel1: [0],
      panel2: [0],
      today: new Date(),
      prtBy: [
        { label: 'Recovery Doc No.', value: 'R' },
        { label: 'Recovery Transaction Date Range', value: 'T' }
      ]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateValidation() {
      if (this.form.prtBy === 'R') {
        return ''
      } else {
        return 'required'
      }
    },
    rcvyDocNoValidation() {
      if (this.form.prtBy === 'T') {
        return ''
      } else {
        return 'required'
      }
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.claimReports.init !== 1) {
        await this.$store.dispatch('claimReportsInit')
      }
      try {
        const apiURI = this.rptMenu.clmRiRcvyR
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.menu = extractMenu(result.data._links)
            this.supportedFormat.push(result.data.data.format[0])
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCloseFilter() {
      this.filterList = false
    },
    async doAssign(Obj) {
      if (Obj) {
        this.form.rcvyDocNo = Obj.rcvyDocNo
        this.form.clmNo = Obj.clmNo
      }
    },
    convertDate(dateString) {
      const date = new Date(dateString)
      const mnth = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return [date.getFullYear(), mnth, day].join('-')
    }
  },
  components: {
    ClaimHelpList
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
</style>
